import Component from './StatsSection';
import Container from './StatsSection.container';

export default Container(Component);
